module.exports = __webpack_public_path__ + "static/media/beverages@3x.4d882a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/beverages@3x.png
// module id = 658
// module chunks = 1